/**
 * @generated SignedSource<<27344990d304833df18f77c069e9dd0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignInFooter_session$data = {
  readonly currentClientProfile: {
    readonly __typename: string;
  } | null | undefined;
  readonly user: {
    readonly firstName: string | null | undefined;
    readonly fullName: string | null | undefined;
    readonly lastName: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "SignInFooter_session";
};
export type SignInFooter_session$key = {
  readonly " $data"?: SignInFooter_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignInFooter_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignInFooter_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "e6cf9c4daa9358922a82462325a7f71d";

export default node;
